import React, { useState } from 'react';
import { Container, Row, Col, Nav, Card, Collapse } from 'react-bootstrap';
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import EntityFiscalDistressOverview from './EntityFiscalDistressOverview';
import EntityFiscalDistressIndividualReports from './EntityFiscalDistressIndividualReports';
import { Tabulator, PageModule, DownloadModule, ExportModule, SortModule } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";

Tabulator.registerModule([PageModule, DownloadModule, ExportModule, SortModule]);

interface FiscalDistress {
  sf_name: string;
  govt_lvl: string;
  year_rank: number;
  year_cnt: number;
  ugf_balance_coverage_above_status_cnt: number;
  ugf_balance_coverage_score: string;
  gov_fund_balance_coverage_above_status_cnt: number;
  gov_fund_balance_coverage_score: string;
  gov_fund_revenue_coverage_above_status_cnt: number;
  gov_fund_revenue_coverage_score: string;
  cash_coverage_of_gov_fund_expenditure_above_status_cnt: number;
  cash_coverage_of_gov_fund_expenditure_score: string;
  debt_service_as_perc_of_gov_fund_below_status_cnt: number;
  debt_service_as_perc_of_gov_fund_score: string;
  accumulated_depreciation_of_depreciable_capital_assets_status_cnt: number;
  accumulated_depreciation_of_depreciable_capital_assets_score: string;
}

const EntityFiscalDistressDashboard = () => {
  const [showHeaderInfo, setShowHeaderInfo] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedEntityName, setSelectedEntityName] = useState<string | null>(null);
  const [masterData, setMasterData] = useState<FiscalDistress[]>([]);
  const [allEntities, setAllEntities] = useState<string[]>([]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <EntityFiscalDistressOverview/>
        )

      case 'individual report':
        return (
          <EntityFiscalDistressIndividualReports
            allEntities={allEntities}
            selectedEntityName={selectedEntityName ?? ""}
            masterData={masterData}
          />
        )
    default:
    }
  };

  return (
    <>
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <Container fluid as="main">
        <Row className="mb-4 px-4">
          <Col xs={12} className="px-0">
            <Card bg="secondary" text="white" style={{ border: "none", borderRadius: "0" }}>
              <Card.Body style={{ justifyItems: "center", textAlign: "center" }}>
              <div className="tu_tabHeader">
                <div className="tu-tabHeader__titleRow">
                  <h1 className="tu-tabHeader__title">
                  Fiscal Distress Dashboard</h1>
                    <button
                    type="button"
                    className="tu-tabHeader__infoBtn"
                    onClick={() => setShowHeaderInfo(!showHeaderInfo)}
                    aria-label="Compare Two Entities info"
                  >
                    <i className="fas fa-info"/>
                    </button>
                  </div>
                </div>
                <Collapse in={showHeaderInfo}>
                  <div>
                    <ol>
                      <li>Warn of potential fiscal distress by monitoring select triggers by monitoring select fiscal indicators (ratios).</li>
                      <li>Prompt further investigation into fiscal distress triggers.</li>
                      <li>Facilitate early and informed dialogue between public officials and administrators regarding their entity's financial condition.</li>
                    </ol>
                  </div>
                </Collapse>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Navigation Tabs */}
        <Container className="mt-4">
          <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'overview')}>
            <Nav.Item>
              <Nav.Link eventKey="individual report">
                <i className="fas fa-clipboard-check tu-tabIcon" aria-hidden="true" />
                <span className="tu-tabLabel">Individual Report</span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="overview">
                <i className="fas fa-chart-pie tu-tabIcon" aria-hidden="true" />
                <span className="tu-tabLabel">Overview</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Container>

        <Container className="mt-4 mb-5">
          {renderTabContent()}
        </Container>
      </Container>
      <FooterSection />
    </>
  )
}

export default EntityFiscalDistressDashboard;